module.exports = __webpack_public_path__ + "static/media/Torterra_gaussian2.c434cffa.png";